'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { StepIndicatorContext } from './step-indicator-context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

let n = {
    currentStepNumber: e$1.number.isRequired,
    showAllSteps: e$1.bool
}, c = Object.keys(n);
const StepIndicator = renderWithRef('StepIndicator', n, (e$1, r)=>{
    useComponentStylesLoaded('StepIndicator', SWAN_STYLE_KEY_MAP.stepIndicator);
    let { currentStepNumber: n = 1, showAllSteps: i } = e$1, m = new Set([
        'swan-step-indicator'
    ]);
    return i && m.add('swan-step-indicator-show-all-steps'), e.createElement(StepIndicatorContext.Provider, {
        value: {
            currentStepNumber: n
        }
    }, e.createElement(RenderComp, {
        root: "div",
        forwardedRef: r,
        propKeysToRemove: c,
        classNames: m,
        props: e$1
    }, e$1.children));
});

export { StepIndicator };
